module.exports = __webpack_public_path__ + "static/media/swicman2.e664f0fc.jpg";